import React, { useState } from "react";
import {
  Card,
  Stack,
  Avatar,
  CardMedia,
  Typography,
  AvatarGroup,
  CardContent,
} from "@mui/material";
import { stringAvatar } from "../../helpers/string-avatar";
const DEFAULT_IMAGE = "/assets/placeholders/no-image.jpg";

const GardenCard = ({ garden }) => {
  const users = Array.isArray(garden.users) ? garden.users : [];
  const baseUrl = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
  const [imgSrc, setImgSrc] = useState(
    garden.image ? `${baseUrl}/${garden.image}` : DEFAULT_IMAGE
  );
  const handleError = () => {
    setImgSrc(DEFAULT_IMAGE);
  };

  return (
    <Card sx={{ bgcolor: "background.default", height: 1 }}>
      <CardMedia
        image={imgSrc}
        alt={garden.name || "Garden Image"}
        onError={handleError}
        sx={{ height: 187 }}
        title={garden.name}
      />
      <CardContent sx={{ height: 110, overflowY: "auto" }}>
        <Typography variant="body1" color="text.secondary" mb={2}>
          {garden.name}
        </Typography>

        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Typography variant="body2">Size</Typography>
          <Typography variant="body2">{garden.area} Acres</Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Typography variant="body2">Location</Typography>
          <Typography variant="body2">{garden.location}</Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Typography variant="body2">Crop</Typography>
          <Typography variant="body2">{garden.crop}</Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between" mb={1}>
          <Typography variant="body2">Status</Typography>
          <Typography variant="body2">{garden.status}</Typography>
        </Stack>

        {users.length > 0 && (
          <Stack mt={2}>
            <AvatarGroup max={4}>
              {users.map((user, idx) => (
                <Avatar
                  key={idx}
                  {...stringAvatar(
                    typeof user === "string" ? user : user?.name || "User"
                  )}
                />
              ))}
            </AvatarGroup>
          </Stack>
        )}
      </CardContent>
    </Card>
  );
};

export default GardenCard;
